import { type ReactNode } from 'react'
import styles from './ModalActions.module.css'

type ModalActionsProps = {
  children: ReactNode
  className?: string
  layout?: 'end' | 'stretch'
}

export const ModalActions = ({ children, className, layout = 'end' }: ModalActionsProps) => (
  <div className={[
    'ui-modal-actions',
    'modal-actions',
    layout === 'stretch' ? 'ui-modal-actions--stretch' : '',
    styles.actions,
    layout === 'stretch' ? styles.stretch : '',
    className
  ].filter(Boolean).join(' ')}>
    {children}
  </div>
)
